<template>
  <div class="row mt-3" v-if="reportData">
    <div class="col-lg-12">
      <div class="row">
        <!-- Session-Wise Doughnut Chart -->
        <div class="col-xl-4 col-lg-5 col-12 mb-3">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body p-3">
              <session-wise-due-chart :reportData="reportData" :selectedSession="selectedSession"></session-wise-due-chart>
            </div>
          </div>
        </div>

        <!-- Fee-Wise Stacked Bar Chart -->
        <div class="col-xl-8 col-lg-7 col-12 mb-3">
          <div class="card shadow-sm border-0 h-100">
            <div class="card-body p-3">
              <fee-wise-due-chart :reportData="reportData" :selectedSession="selectedSession"></fee-wise-due-chart>
            </div>
          </div>
        </div>
      </div>

      <!-- Class-Wise Stacked Bar Chart -->
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body p-3">
          <class-wise-due-chart :reportData="reportData" :selectedSession="selectedSession"></class-wise-due-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SessionWiseDueChart from './charts/sessionwise/sessionwiseduechart'
import FeeWiseDueChart from './charts/feewise/feewiseduechart'
import ClassWiseDueChart from './charts/classwise/classwiseduechart'

export default {
  name: 'FeeReportChart',
  components: {
    SessionWiseDueChart,
    FeeWiseDueChart,
    ClassWiseDueChart,
  },
  props: {
    reportData: Object,
    selectedSession: Object,
  },
}
</script>
